// extracted by mini-css-extract-plugin
export var drawerContainer = "hamburgerMenu-module--drawer-container--e0033";
export var drawerContent = "hamburgerMenu-module--drawer-content--d25bd";
export var hamburgerButton = "hamburgerMenu-module--hamburger-button--93882";
export var menuSection = "hamburgerMenu-module--menu-section--e0a03";
export var sectionTitle = "hamburgerMenu-module--section-title--2d5db";